<template>
  <div>
    <div>
      <div class="my-3">
        <div class="rounded border h-14 text-sm bg-backgroundGrey flex flex-row justify-around">
          <span class="my-auto mx-2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 7H11V5H9V7ZM9 15H11V9H9V15ZM10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 8.68678 0.258657 7.38642 0.761204 6.17317C1.26375 4.95991 2.00035 3.85752 2.92893 2.92893C3.85752 2.00035 4.95991 1.26375 6.17317 0.761205C7.38642 0.258658 8.68678 0 10 0Z"
                fill="#F7B538" />
            </svg></span>
          <span>The account owner is a default role assigned to the account
            creator. This role is restricted and can not be assigned to another
            users but may be transferred. You will cease to be the account owner
            as soon as you transfer.</span>
        </div>
      </div>
      <div>
        <h2 class="font-bold">Account Owner</h2>
        <div class="custom-card mb-4">
          <div class="container">
            <div class="row">
              <div class="col-md-5 flex flex-row">
                <div class="w-[70px]">
                  <b-avatar
                    :src="user.Org.imageurl || 'https://s3-alpha-sig.figma.com/img/080e/5e96/1f10eb911a32b0b791a3469cc3b8c5dc?Expires=1672617600&Signature=qA1IHuvuYttkbRXKjqYLt56vFGi9oYCcGuKZo9K3BNM0wrHBSjG1nN9tg6kyJmPpnz2MohM30qb2W24vnmu8UvvKPuv0-GK2OPmPVBizg1JyxzhrYzLqgx2i2e4bT~V35ncZRA1jkR5OT-0go4IhcSaI5zR~2uUZGIUegh7KWSIWwwXYx9FsQ9M-nlhS6Dhbur~mgl2IJ8qOf1f14QzDMGk6RxQvMFDH8OKhsocn8aV9oWDzHmsO2eN6wwQwsd7Bxq-beEqZkAd-9swiZQm2NuANj2AJJAK~N9gURoUGLgeemd2ed7355ZjKpgMVfMYjUIFMecDArhV9IKcnWnVDMw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4'"
                    size="4.5rem" id="avatar">
                  </b-avatar>
                </div>
                <div class="my-auto mx-3">
                  <span>NAME: {{ user.firstname || "" }} {{ user.middlename || "" }}
                    {{ user.lastname }}</span>
                  <br />
                  <span>EMAIL: {{ user.email }}</span>
                </div>
              </div>
              <div class="col-md-3 d-flex">
                <div class="my-auto">
                  <span>DATE CREATED: {{ user.createdAt | formatDate }}</span>
                  <br />
                  <span>PHONE: {{ user.mobile_no }}</span>
                </div>
              </div>
              <div class="col-md-3 offset-md-1 border-left d-flex disabled-overlay">
                <button class="my-auto mx-auto" @click="confirmTransfer = true">
                  <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" class="float-left mx-1">
                    <path fill="currentColor"
                      d="M11 10V12H9V14H7V12H5.8C5.4 13.2 4.3 14 3 14C1.3 14 0 12.7 0 11S1.3 8 3 8C4.3 8 5.4 8.8 5.8 10H11M3 10C2.4 10 2 10.4 2 11S2.4 12 3 12 4 11.6 4 11 3.6 10 3 10M16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14M16 12C13.8 12 12 10.2 12 8S13.8 4 16 4 20 5.8 20 8 18.2 12 16 12Z" />
                  </svg>
                  <span class="float-right">Transfer Ownership</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr style="border-top: dashed 1px" />
        <div class="my-5">
          <h2 class="font-bold">Access Control</h2>
          <p>
            Select which modules and associated actions/forms to grant access
            to.
          </p>
        </div>
      </div>
      <!-- <div v-if="roles.length < 1"> -->
      <div v-if="allRoles.length < 1">
        <span>
          <empty-roles-icon class="mx-auto"></empty-roles-icon>
        </span>
        <div class="font-bold mx-auto text-center my-3">
          <h2>Looks like you have not added any roles and privileges</h2>
        </div>
        <div style="width: 731px" class="mx-auto my-3 text-center text-base">
          You can create other role types and assign module specific privileges
          to them. You can always return at any time to edit the privileges of
          any created roles. Click to start creating roles.
        </div>
        <div class="flex justify-around flex-row">
          <base-button @click="createNewRole(true)" text="Create New Role" />
        </div>
      </div>
      <!-- <template v-else>  -->
      <template v-if="allRoles.length > 0">

        <div class="d-flex flex-row justify-content-end my-3">
          <button style="width: 157px; height: 48px" @click="showModal = !showModal"
            class="border-2 border-black rounded py-1 px-2 font-normal mr-4">
            My Subscriptions
          </button>
          <base-button @click="createNewRole(true)" text="Create New Role" />
        </div>
        <div class="d-flex flex-row justify-content-between">
          <div class="table__search-input-wrapper my-auto" style="width: 467px">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input type="text" class="table__search-input" placeholder="Search..." v-model="search" />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
          <div class="date-picker custom-card flex items-center justify-center" v-if="dateFilter == 'custom'">
            <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
            <span>To</span>
            <el-date-picker class="ml-3" type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
          </div>
          <div>
            <el-dropdown trigger="click" class="h-full w_semi">
              <div class="drp-content">
                <span>
                  <img src="../../../../views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
                  <abbr class="vrt_line"></abbr>
                  <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
                </span>
                <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button @click="setFilterType('day', 'Today')">Today</button>
                </el-dropdown-item>

                <el-dropdown-item>
                  <button @click="setFilterType('week', 'This Week')">This Week</button>
                </el-dropdown-item>

                <el-dropdown-item>
                  <button @click="setFilterType('month', 'This Month')">This Month</button>
                </el-dropdown-item>
                
                <el-dropdown-item>
                  <button @click="setFilterType('year', 'This Year')">This Year</button>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                  <button @click="setFilterType('lastyear', 'Last Year')">Last Year</button>
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <button @click="setFilterType('all', 'All Time')">All Time</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('custom', 'Custom')">Custom</button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="my-4">
          <table class="custom-table responsive-table">
            <thead>
              <tr class="custom-card">
                <th class="width-xs">
                  <base-checkbox v-model="shouldSelectRow" />
                </th>
                <th>Role Name</th>
                <th>Description</th>
                <th>Date Created</th>
                <th>Assigned To</th>
                <th class="width-xs">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.7">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                        fill="#383F51" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                        fill="#383F51" />
                    </g>
                  </svg>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(role, i) in filteredRoles" :key="i" class="cursor-pointer custom-card">
                <td>
                  <base-checkbox value="booking.id" v-model="selectedRow" />
                </td>
                <td>
                  <span>
                    {{ role.name }}
                  </span>
                </td>
                <td>
                  {{ role.description }}
                </td>
                <td>
                  {{ role.createdAt | formatDate }}
                </td>
                <td>
                  <span v-if="role.assignedUsers.length">
                    {{ role.assignedUsers.length !== "0" ? role.assignedUsers.length : "" }} user(s)
                  </span>
                  <span v-else class="text-danger">Unassigned</span>
                  <span @click="getRoleUsers(role)" class="text-success">
                    View
                  </span>

                </td>

                <td class="ml-3 cursor-pointer relative" tabindex="-1">
                  <el-dropdown>
                    <button>
                      <vertical-ellipsis />
                    </button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <button class="flex items-center" @click="getRoleUsers(role)">
                          <eye-icon />
                          <span class="ml-2">View Privileges</span>
                        </button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <button class="flex items-center" @click="editPriveledge(role.id)">
                          <edit-icon />
                          <span class="ml-2">Edit </span>
                        </button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <button @click="deleteRole(role)" class="flex items-center">
                          <cancel-icon />
                          <span class="ml-2">Delete</span>
                        </button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination :pageNumber="pageNumber" />

      </template>
    </div>
    <!--Confirm Transfer Ownership Modal -->
    <modal width="400" @close-modal="confirmTransfer = false" title="Transfer Ownership" :showModal="confirmTransfer">
      <p>
        This action transfers the account ownership and all associated
        privileges to the selected user. Are you sure you wish to proceed?
      </p>
      <div class="d-flex flex-row-reverse justify-content-end mt-4">
        <base-button text="Proceed" @click="authUser"></base-button>
        <button style="width: 157px; height: 48px" @click="confirmTransfer = false"
          class="border-2 border-black rounded py-1 px-2 font-normal mr-4">
          Cancel
        </button>
      </div>
    </modal>
    <!--Delete Role Modal -->
    <modal width="400" @close-modal="deleteModal = false" title="Delete role" :showModal="deleteModal">
      <p>
        Are you sure you want to delete the
        <b class="text-danger">{{ deleteItem.name }}</b> Role? This action
        cannot be undone.
      </p>
      <div class="d-flex flex-row-reverse justify-content-end mt-4">

        <base-button text="Proceed" @click="confirmDelete(deleteItem.id)"></base-button>

        <button style="width: 157px; height: 48px" @click="deleteModal = false"
          class="border-2 border-black rounded py-1 px-2 font-normal mr-4">
          Cancel
        </button>
      </div>
    </modal>
    <!-- User Auth Modal -->
    <modal width="500" @close-modal="otpModal = false" title="Transfer Ownership" :showModal="otpModal">
      <div class="my-3 flex flex-row justify-between" v-if="!isPassword">
        <div class="password-input-field_wrapper">
          <input type="password" class="auth-input-field" placeholder="Password" id="password" v-model="password" />
        </div>
        <base-button text="Verify" @click="confirmPassword"></base-button>
      </div>
      <div v-else>
        <div class="my-3">
          <label for="select-user">Select User
            <tooltip text="Select the user that you wish to transfer your account ownership to.
You will cease to be the account owner as soon as you complete the transfer."><span> <img
                  src="@/assets/images/icons/info.svg" alt="" /> </span></tooltip>
          </label>
          <el-select filterable v-model="selectedQuantumUser" placeholder="Select">
            <el-option :label="`${user.firstname} ${user.lastname}`" :value="user.id" v-for="(user, i) in quantumUsers"
              :key="i">
            </el-option>
          </el-select>
        </div>
        <VerifyOtp :payload="payload" @close-modal="otpModal = false" :transferPayload="transferPayload" />
      </div>
      <div class="d-flex flex-row-reverse my-3">
        <button v-if="!isPassword" style="width: 157px; height: 48px" @click="otpModal = false"
          class="border-2 border-black rounded py-1 px-2 font-normal">
          Cancel
        </button>
      </div>
    </modal>

    <!-- Action/Privileges  modal -->

    <!-- <preview-modal @open-users-modal="showUsersModal = true" @close-action-modal="actionPrivilege = false"
      :rolePrivileges="rolePrivileges" :actionPrivilege="actionPrivilege"
      :assignedUsers="assignedUsers"></preview-modal> -->
    <preview-modal @open-users-modal="showUsersModal = true" @close-action-modal="closeViewModal"
      :rolePrivileges="rolePrivileges" :actionPrivilege="actionPrivilege"
      :assignedUsers="assignedUsers"></preview-modal>




    <!-- view all users modal -->
    <modal :showModal="showUsersModal" width="500" @close-modal="showUsersModal = false">
      <div class="user-title-wrap">
        <span style="font-size: 24px; cursor: pointer; color: #080056" @click="showUsersModal = false">&#8592;</span>
        <h1 style="font-size: 24px; font-weight: 700;  color: #080056;">Role Assigned To</h1>
      </div>

      <p style="font-size: 16px; font-weight: 400; color: #14171F">These users have been assigned the <span
          style="font-size: 16px; font-weight: 400; color: #114FF5">Admin</span> role...</p>

      <div class="flex justify-between mt-8 user-name-wrap" v-for="(user, i) in assignedUsers" :key="i">
        <p style="font-size: 14px; font-weight: 600; color: #1F1514">{{ user.firstname }} {{ user.lastname }}</p>
        <p style="font-size: 14px; font-weight: 400; color: #114FF5">Admin</p>
      </div>
    </modal>
    <loader v-if="loading === true" />
  </div>
</template>

<script>
import moment from "moment";
import debounce from "@/utilities/debounce";

import Tooltip from "@/components/UI/Tooltip";
import VerifyOtp from "./VerifyOTP.vue";
//@ts-ignore
import PreviewModal from "./PreviewModal.vue";
import pagination from "@/components/UI/pagination";
import Modal from "./Modal.vue";


export default {
  components: {
    pagination,
    VerifyOtp,
    PreviewModal,
    Tooltip,
    Modal,
  },
  props: {
    allRoles: {
      type: Array,
      default: () => ([]),
    },
    shouldCreateNew: {
        type: Function
    },
    createRolefunc: {
      type: Function
    }
  },
  data() {
    return {

      filterTitle: 'This Month',
      startDate: "",
      endDate: "",
      dateFilter: "month",
      selectedQuantumUser: "",
      showPasswordIcon: true,
      currentTab: "Sub-Module3",
      privileges: [],

      deleteItem: "",
      isPassword: false,
      password: "",
      otpModal: false,
      showUsersModal: false,
      pageSize: null,
      pageNumber: 1,
      totalRoles: null,
      viewAssigned: false,
      actionPrivilege: false,
      deleteModal: false,
      transferModal: false,
      confirmTransfer: false,
      search: "",

      quantumUsers: [],


      rolePrivileges: {},
      viewRoleId: "",
      assignedUsers: [],


      roleUsers: [],
      loading: false,
      shouldSelectRow: false,
      modules: [
        {
          label: "Booking & Shipments",
          value: "Booking&Shipments",
        },
        {
          label: "Billings & Payments",
          value: "Billings&Payments",
        },
        {
          label: "Location",
          value: "Location",
        },
        {
          label: "Settings",
          value: "Settings",
        },
        {
          label: "Routes",
          value: "Routes",
        },
        {
          label: "Customers",
          value: "Customers",
        },
        {
          label: "User",
          value: "User",
        },
      ],
      selectedRow: [],
      roles: [],
    };
  },
  mounted() {
    this.getRoles();
    // this.getQuantumUsers();
    this.getUsers();
  },

  methods: {
    closeViewModal() {
      this.actionPrivilege = false;
      this.viewRoleId = null;
      this.rolePrivileges = {};
    },

    createNewRole() {
      this.createRolefunc();
      this.shouldCreateNew(true);
    },
    editPriveledge(val) {
      this.$emit('editRoles', val)
      this.shouldCreateNew(true);
    },

    async getUsers() {
      try {
        const response = await this.$_getMuleExUsers();
        this.quantumUsers = response.data.data;
        console.log(JSON.stringify(response.data, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },

    authUser() {
      this.otpModal = true;
      this.confirmTransfer = false;
    },
    openTransferModal() {
      this.transferModal = true;
      this.confirmTransfer = false;
    },

    deleteRole(role) {
      this.deleteModal = true;
      this.deleteItem = role;
      // this.actionPrivilege = false

    },
    async confirmPassword() {
      try {
        const response = await this.$_confirmUserPassword(this.payload);
        if (response.data.success) {
          this.generateToast(response.data.message, "success");
          this.isPassword = true;
          this.requestOtp();
        } else {
          this.$_showErrorToast(response.data.message);
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async requestOtp() {
      const response = await this.$_requestOTP(this.payload);
      console.log(JSON.stringify(response.data));
    },
    async confirmDelete(roleId) {
      try {
        const response = await this.$_deleteRole(roleId);
        if (response.data.success === true) {
          this.generateToast(response.data.message, "success");
          this.deleteModal = false;
          this.getRoles();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getRoleUsers(role) {

      if (role && role.id) {
        this.assignedUsers = role.assignedUsers;
        this.viewRoleId = role.id;
        this.actionPrivilege = true;
      } else {
        this.generateToast("No role selected", "error");
      }
      try {

        const response = await this.$_viewRole(this.viewRoleId);
        if (response.data.success === false) {
          this.generateToast(response.data.message, "error");
          return;
        } else {
          this.rolePrivileges = response.data.data;
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.loadingPrivileges = false;
      }
    },



    async getRoles() {
      this.isLoading = true;
      try {
        let response = await this.$_getRoles(this.dateFilterpayload);
        if (response.data.success === true) {
          this.roles = response.data.data;
          // this.totalRoles = response.data.roles.length
          this.totalRoles = this.roles.length

        }
      } catch (error) {
        console.log(error);
      }
    },



    async getRoleAndItsUsers(roleId) {
      try {
        let response = await this.$_getUsersInRole(roleId);
        this.roleUsers = response.data.data.users;
      } catch (error) {
        console.log(error);
      }
    },
    setFilterType(val, title) {
      this.dateFilter = null
      this.dateFilter = val
      this.filterTitle = title
      if (this.dateFilter != "custom") {
        this.getRoles();
        this.startDate = ""
        this.endDate = ""
      }
    },
  },
  watch: {
    "sortProps": debounce(function () {
      if (this.dateFilter == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {
        this.dateFilterpayload.startDate = this.sortProps.startDate;
        this.dateFilterpayload.endDate = this.sortProps.endDate
        this.getRoles();

      }
    }, 500),
    // createRole() {
    //   this.getRoles();
    //   this.getQuantumUsers();
    // },


  },
  computed: {
    sortProps() {
      return {
        dateFilter: this.dateFilter,
        startDate: this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },

    dateFilterpayload() {
      return {
        dateFilter: this.sortProps.dateFilter,
        startDate: "",
        endDate: ""
      };
    },


    filteredRoles() {
      return this.filterArray(this.roles, this.search)
    },
    user() {
      return JSON.parse(localStorage.getItem("loggedInUser"));
    },
    quantumUserId() {
      return this.$store.state.authentication.quantumUserId;
    },
    payload() {
      return {
        userId: this.quantumUserId,
        password: this.password,
      };
    },
    transferPayload() {
      return {
        roleId: "3e315dec-a184-411c-889f-4f6502d3e45c",
        newOwnerId: this.selectedQuantumUser,
        //  currentRootAdminId: this.quantumUserId,
        //  newRootAdminId: this.selectedQuantumUser,
        //  otp: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled-overlay {
  pointer-events: none;      
  opacity: 0.5;              
}
.user-name-wrap {
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 6px 0 #2E294E14;
}

.user-title-wrap {

  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.user-title-wrap>span {
  padding-right: 2%;

  border-right: 1px solid #C5C4D4;
  margin-right: 5px;
}

#avatar>span>img {
  object-fit: cover;
}

.password-input-wrapper div {
  margin: 2rem 0;
}

.password-input-field_wrapper {
  position: relative;
}

.view-password svg {
  position: absolute;
  right: 1rem;
  top: 1rem;
  opacity: 0.5;
  cursor: pointer;
}

.password-info {
  color: rgba(82, 82, 82, 0.7);
}

.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>